import { useAuction } from '@autobid/ui/composables/useAuction'
import { useAuctionId } from '@autobid/ui/composables/useAuctionId'
import { useAuctionPagesLink } from '@autobid/ui/composables/useAuctionPagesLink'
import { computed } from 'vue'

const PAGE_TYPES = {
  'auction-slug': 'carList',
  'item-slug': 'barometer',
  'item-slug-details': 'details',
  'item-slug-preview': 'detailsPreview',
  'auction-current-slug': 'barometerCurrent',
  'beamer-auctionId-interior': 'beamerInterior',
  'beamer-auctionId-exterior': 'beamerExterior',
  'beamer-auctionId': 'beamer',
} as const

export type AuctionPageType =
  | (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES]
  | 'carSearch'

export function getPageType(routePageName: string) {
  const [baseRouteName] = routePageName.split('___')

  return PAGE_TYPES[baseRouteName as keyof typeof PAGE_TYPES]
}

export function useCarPageType() {
  const router = useRouter()

  return computed(() => {
    const routePageType = getPageType(String(router.currentRoute.value.name))

    if (routePageType)
      return routePageType

    return 'carSearch'
  })
}

export function useCarPageInfo() {
  const auctionId = useAuctionId()
  const { auction } = useAuction(auctionId.value)
  const router = useRouter()
  const { getLink } = useAuctionPagesLink()
  const pageType = useCarPageType()

  const backUrl = computed(() => {
    switch (pageType.value) {
      case 'carList':
        return undefined
      case 'details':
        return getLink({
          page: 'barometer',
          slug: String(router.currentRoute.value.params.slug),
        })
      case 'barometer':
        return auction.value?.slug ? getLink({ page: 'car-list', slug: auction.value.slug }) : undefined
      case 'barometerCurrent':
        return getLink({
          page: 'car-list',
          slug: String(router.currentRoute.value.params.slug),
        })
    }

    return undefined
  })

  return { pageType, backUrl }
}
